import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Select, Form, Input, notification} from 'antd';

import {getStaffRole, updateStaffRole} from './actions';
import {bindActionCreators} from "redux";
import {getDescriptionFromError} from "../utils/errors";

import permissionChoices from "./permissions";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateStaffRoleForm extends Component {
  componentDidMount() {
    this._loadStaffRole();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.staffRoleId !== this.props.match.params.staffRoleId) {
      this._loadStaffRole();
    }
  }

  _loadStaffRole = () => {
    const {staffRoleId} = decodeParams(this.props.match.params);
    this.props.getStaffRole({staffRoleId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {staffRoleId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) return;
      this.props.updateStaffRole({...values, staffRoleId})
        .then(this.goBack)
        .catch(err => notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        }));
    });
  };

  render() {
    const {staffRole, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, permissions} = staffRole;
    return (
      <Card title="Update Staff Role">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Permissions"
          >
            {getFieldDecorator('permissions', {
              rules: [],
              initialValue: permissions
            })(
              <Select mode="multiple" placeholder="Select permissions">
                {permissionChoices.map(({value, text}) => <Option key={value} value={value}>{text}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Staff Role
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateStaffRoleForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  getStaffRole: PropTypes.func.isRequired,
  staffRole: PropTypes.object.isRequired,
  updateStaffRole: PropTypes.func.isRequired
};

const UpdateStaffRolePage = Form.create()(UpdateStaffRoleForm);

const mapStateToProps = state => ({
  loading: state.staffRole.staffRoleLoading || state.staffRole.updatingStaffRole,
  staffRole: state.staffRole.staffRole || {},
});

const mapDispatchToProps = dispatch => ({
  getStaffRole: payload => (dispatch(getStaffRole(payload))),
  updateStaffRole: bindActionCreators(updateStaffRole, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateStaffRolePage);



// WEBPACK FOOTER //
// ./src/StaffRole/UpdateStaffRolePage.js